import classNames from "classnames"
import { twMerge } from "tailwind-merge"

type ClassValue = ClassArray | ClassDictionary | string | number | bigint | null | boolean | undefined
type ClassDictionary = Record<string, any>
type ClassArray = ClassValue[]

export const cn = (...inputs: ClassValue[]) => {
    return twMerge(classNames(inputs))
}
